module.exports = __webpack_public_path__ + "static/media/39C765_0_0.c880ac48.woff2";